// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/gyro-instrument-limits.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/gyro-instrument-limits/gyro-instrument-limits.js';
import g1 from '../lessons/aeronautics/gyro-instrument-limits/heading-indicator-reset.js';

mount([g0, g1]);
